import View from './view';
export const ContentWithRightImage = View;
